module.exports = __webpack_public_path__ + "img/folder-grid.4f5afa72.svg";